import { $size as __size, createQueryOperator } from "../../_predicates";
const $size = createQueryOperator(__size);
export {
  $size
};
